import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {Subject} from 'rxjs';
import {IDialogView} from '@shared/components/ok-cancel-dialog/ok-cancel-dialog.component';
import {InboxState} from '../../store/reducers/inbox.reducers';
import {Store} from '@ngrx/store';
import {GetMailByIdAction} from '../../store/actions/inbox.actions';
import {getCurrentMail} from '../../store/selectors/inbox.selectors';
import {takeUntil} from 'rxjs/operators';
import {DialogModel} from '@shared/models/dialog.model';
import {EmailThread} from '@features/inbox/interfaces/email-thread-label';
import {InboxControllerService} from '@features/inbox/services/inbox-controller.service';

@Component({
    standalone: false,
    selector: 'particle-mail-thread',
  templateUrl: './mail-thread.component.html',
  styleUrls: ['./mail-thread.component.scss']
})
export class MailThreadComponent implements OnInit, IDialogView, OnDestroy {
  mailId: any;
  reply: any;
  unSubscribe$ = new Subject<void>();
  mailThread: any;
  mailContents: any[];
  currentMailId: string;
  temp: string;
  isShowReply: boolean;
  data: DialogModel;
  emailThread: EmailThread = {} as EmailThread;

  constructor(private store: Store<InboxState>,
              private inboxControllerService: InboxControllerService) {
  }

  ngOnInit() {
    this.inboxControllerService.currentMailId$.subscribe((data: any) => {
      this.temp = data;
      // this.currentMailId = this.data.input.mailId;
      this.currentMailId = data;
      // this.isShowReply = this.data.input.reply;
      this.isShowReply = this.reply;
      this.store.dispatch(new GetMailByIdAction(this.currentMailId));
      this.store.select(getCurrentMail).pipe(takeUntil(this.unSubscribe$)).subscribe((payload: any) => {
        if (payload) {
          // this.data.title = payload.mailThread.title;
          this.mailThread = payload.mailThread;
          this.mailContents = payload.mailContents;
          this.emailThread.labels = [];
          this.emailThread.emails = [];
          for (let i = 0; i < this.mailThread.labels.length; i++) {
            this.emailThread.labels.push({
              title: this.mailThread.labels[i],
              color: '#eb3475'
            });
          }
          for (let i = 0; i < this.mailContents.length; i++) {
            this.mailContents[i].isLastMail = false;
            this.emailThread.emails.push({
              content: this.mailContents[i].transformedMessage,
              recipients: {
                cc: this.mailContents[i].recipients,
                to: this.mailContents[i].recipients[0]
              },
              isImportant: true,
              sender: this.mailContents[i].createdBy,
              sentTime: new Date(this.mailContents[i].createdDate)
            });
          }
          console.log(this.emailThread);
          if (this.mailContents.length > 0) {
            this.mailContents[this.mailContents.length - 1].isLastMail = true;
            for (let i = 0; i < this.mailContents.length - 1; i++) {
              this.mailContents[i].isLastMail = false;
            }
          }
        }
      });
    });
  }

  discardMsg(event: any) {

  }

  onOkClicked(): boolean {
    return true;
  }

  ngOnDestroy() {
    this.unSubscribe$.next();
    this.unSubscribe$.complete();
  }
}
